import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useIaJobs } from '../context/IaJobsProvider';
import { userApi } from '../services/api';
import IaFeedbackResultModal from './IaFeedbackResultModal';

export default function IaFeedbackReviewHost() {
  const { user, refreshUser } = useAuth();
  const {
    feedbackReview,
    feedbackModalOpen,
    setFeedbackModalOpen,
    clearFeedbackReview,
    registerFeedbackReviewOpen,
  } = useIaJobs();
  const [autoOpen, setAutoOpen] = useState(user?.iaFeedbackAutoOpen !== false);

  useEffect(() => {
    setAutoOpen(user?.iaFeedbackAutoOpen !== false);
  }, [user?.iaFeedbackAutoOpen]);

  useEffect(() => {
    return registerFeedbackReviewOpen(() => setFeedbackModalOpen(true));
  }, [registerFeedbackReviewOpen, setFeedbackModalOpen]);

  useEffect(() => {
    if (feedbackReview && autoOpen) {
      setFeedbackModalOpen(true);
    }
  }, [feedbackReview, autoOpen, setFeedbackModalOpen]);

  const handleAutoOpenChange = async (next) => {
    setAutoOpen(next);
    if (user?.id) {
      try {
        await userApi.update(user.id, { iaFeedbackAutoOpen: next });
        await refreshUser();
      } catch (e) {
        console.warn('iaFeedbackAutoOpen:', e);
      }
    }
  };

  const title =
    feedbackReview?.type === 'set_feedback'
      ? 'Análise do set'
      : feedbackReview?.type === 'exercise_complete'
      ? 'Resumo do exercício'
      : 'Análise IA';

  return (
    <IaFeedbackResultModal
      open={feedbackModalOpen && !!feedbackReview}
      title={title}
      contextLabel={feedbackReview?.contextLabel}
      markdown={feedbackReview?.markdown}
      autoOpen={autoOpen}
      onAutoOpenChange={handleAutoOpenChange}
      onClose={() => {
        setFeedbackModalOpen(false);
        clearFeedbackReview();
      }}
    />
  );
}
